export const PACKAGE_NAME = '@atlassian/jira-lock-screen-experiment-shared';
export const TEAM_NAME = 'transmuters-growth';
